import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { icons } from '../../../../helpers/icons';
import { ButtonRegular } from '../../buttons/ButtonRegular';

interface IEvaluationButton {
  evaluationLink: string;
  isEvaluated: boolean;
}

const EvaluationButton: React.FC<IEvaluationButton> = ({
  evaluationLink,
  isEvaluated,
}) => {
  const [evaluated, setEvaluated] = useState(isEvaluated);
  return (
    <>
      {evaluated ? (
        <div className="flex items-center gap-2">
          <div>
            <img src={icons.tickCircle} alt="" />
          </div>
          <div className="font-medium text-green-900 text-regular">
            Submitted
          </div>
        </div>
      ) : (
        <Link to={evaluationLink} target="_blank">
          <ButtonRegular
            onClick={() => setEvaluated(true)}
            className="button-primary"
            text="Submit evaluation"
          />
        </Link>
      )}
    </>
  );
};

export default EvaluationButton;
